import {Component, Input, OnInit} from '@angular/core';
import {CustomFormControl} from '../CustomFormControl';
import {UntypedFormGroup} from '@angular/forms';
import {FileOnlineViewModel} from '../../../FileOnlineViewModel';

@Component({
  selector: 'app-control-grid',
  templateUrl: './control-grid.component.html',
  styleUrls: ['./control-grid.component.scss']
})
export class ControlGridComponent implements OnInit {

  @Input() control!: CustomFormControl;
  @Input() pageFormGroup!: UntypedFormGroup;
  @Input() viewModel!: FileOnlineViewModel;
  @Input() controls!: Map<string, CustomFormControl>;

  constructor() { }

  ngOnInit(): void {
  }

  get getDynamicStyle(): any {
    return {
      display: 'grid',
      'grid-template-columns': `repeat(${this.control.element.gridControls[0].length}, 1fr)`,
      gap: '10px'
    };
  }

}
